// extracted by mini-css-extract-plugin
export default {"body":"Total_body__lzx+o","btn":"Total_btn__+uHWj"};